import React, { useState, useEffect, useRef, useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import Papa from "papaparse";
import { API, graphqlOperation } from "aws-amplify";
import { createPricelist } from "../../graphql/mutations";
import { Alert, Loader, Text } from "@aws-amplify/ui-react";
import { listPricelists, listUsers } from "../../graphql/queries";
import { Storage } from "aws-amplify";
import {
  IconButton,
  Stack,
  Box,
  ListItem,
  Snackbar,
  ListItemText,
  ListItemButton,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
  Button,
  TextField,
  Slider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import StarIcon from "@mui/icons-material/Star";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import EditIcon from "@mui/icons-material/Edit";
import StarIconOutline from "@mui/icons-material/StarOutlineOutlined";
import { AppContext } from "../../App"; // Import the AppContext from App.js
import UserCard from "../user/UserCard";
import PartCard from "../PartCard";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

const CreatePricelist = ({
  handleUpload,
  csvFile,
  alert,
  setAlert,
  parseCSV,
}) => {
  const [priceListName, setPriceListName] = useState(
    csvFile ? csvFile.name : null,
  );
  const [basePriceList, setBasePriceList] = useState(
    csvFile ? csvFile.name : null,
  );
  const [notes, setNotes] = useState("");

  console.log("got csvFile in step 2", csvFile);

  const samplePart = {
    partNumber: "Example Part 123",
    minPrice: 100,
    maxPrice: 100,
    image1: "noimage.jpg",
  };

  const theme = useTheme();

  return (
    <div style={{ margin: "40px" }}>
      <Typography
        sx={{
          marginTop: "10px",
          marginBottom: "10px",
          textAlign: "center",
          fontWeight: "bold",
          fontFamily: "Poppins",
        }}
      >
        Step 2 - Name Your New Price List
      </Typography>

      <Stack spacing={3} sx={{ marginTop: "30px" }}>
        <TextField
          label="New Price List Name"
          placeholder="Enter the name of your new price list"
          value={priceListName}
          onChange={(e) => setPriceListName(e.target.value)}
        />
        <TextField
          label="Original Filename"
          placeholder="Original Filename"
          value={basePriceList}
          disabled={true}
          onChange={(e) => setBasePriceList(e.target.value)}
        />

        <TextField
          label="Notes"
          placeholder="Enter any notes or additional information"
          multiline={true}
          rows={4}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />

        <Box sx={{ my: 4 }}>
          <Typography
            variant="h6"
            sx={{
              textAlign: "center",
              mb: 3,
              fontWeight: "bold",
            }}
          >
            Pricelist Preview
          </Typography>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={3}
            sx={{
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              mb: 4,
            }}
          >
            <Box sx={{ width: "45%", textAlign: "center" }}>
              <Typography
                sx={{
                  backgroundColor: "black",
                  color: "white",
                  fontWeight: "bold",
                  py: 1,
                  px: 2,
                  borderRadius: "10px",
                  mb: 2,
                  display: "inline-block",
                }}
              >
                Sample Part Price
              </Typography>
              <PartCard part={samplePart} showPrice={true} />
            </Box>
          </Stack>
        </Box>

        {alert ? (
          <Box
            sx={{
              mt: 3,
              p: 3,
              backgroundColor: theme.palette.background.paper,
              borderRadius: "10px",
            }}
          >
            <Typography
              variant="h5"
              sx={{ textAlign: "center", fontWeight: "bold", mb: 2 }}
            >
              Are you ready to upload?
            </Typography>
            <Typography variant="h6" sx={{ textAlign: "center", mb: 3 }}>
              {alert.validRows} part(s) will be uploaded.
              {alert.droppedRows > 0 &&
                ` ${alert.droppedRows} part(s) will be dropped. Row numbers: ${alert.droppedRowIndices.join(
                  ", ",
                )}`}
            </Typography>
            <Stack
              direction="row"
              spacing={2}
              sx={{
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Button
                size="large"
                color="warning"
                variant="contained"
                onClick={() => setAlert(null)}
              >
                CANCEL
              </Button>
              <Button
                size="large"
                variant="contained"
                color="success"
                onClick={() => {
                  handleUpload({
                    filename: basePriceList,
                    name: priceListName,
                    notes: notes,
                  });
                }}
              >
                UPLOAD
              </Button>
            </Stack>
          </Box>
        ) : (
          <Button
            onClick={parseCSV}
            variant="contained"
            size="large"
            color="primary"
            sx={{ mt: 2 }}
          >
            Confirm and Assign
          </Button>
        )}
      </Stack>
    </div>
  );
};

export default CreatePricelist;
